import { Typography } from "@mui/material";

const Label: React.FC = (props) => {
  return <Typography variant="subtitle2">{props.children}</Typography>;
};

export default Label;
